exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-upload[data-v-8ecf3538] {\n  display: block !important;\n}\n.color-control[data-v-8ecf3538] {\n  width: 200px;\n}\n.column-color[data-v-8ecf3538] {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n.design[data-v-8ecf3538] {\n  background: #F7F7F7;\n  border: 1px solid #F7F7F7;\n  border-radius: 4px;\n  display: block;\n  padding-top: 14px;\n  margin-bottom: 7px;\n}\n.subtitle[data-v-8ecf3538] {\n  color: #757575;\n}\n.cont-logo[data-v-8ecf3538] {\n  margin: 10px 10px 10px 10px;\n  padding-bottom: 10px;\n}\n.menu-cha .menu-icon span[data-v-8ecf3538] {\n  margin-top: 5px !important;\n}", ""]);

// exports
